import $http from '../../axios-instance';
import Swal from 'sweetalert2'
import { validarPermisoComponente } from '../../plugins/acl';

/**
 * @param state
 * @param commit
 * @returns {Promise<void>}
 */
export async function listarFabricantes({state, commit}) {

  commit('dashboard/load', true, {root:true})

  await $http.get('/fabricantes', {params: state.filtro})
    .then((response) => {
      commit('setFabricantes', response.data.fabricantes)
    })
    .catch((error) => {
      Swal.fire({
        position: 'center',
        icon: 'error',
        title: 'Error al cargar fabricantes: ' + error,
        showConfirmButton: false,
        timer: 1500
      })
    })

  commit('dashboard/load', false, {root:true})

}

/**
 * @param commit
 * @param id
 * @returns {Promise<void>}
 */
export async function obtenerFabricante({commit}, id) {
  try{
    commit('dashboard/load', true, {root: true});
    const response = await $http.get('/fabricantes/' + id);
    commit('setFabricante', response.data.fabricante);
    return Promise.resolve(response.data.fabricante);
  }catch (error) {
    this.$swal({
      position: 'center',
      icon: 'error',
      title: 'Error al obtener el fabricante: ' + error,
      showConfirmButton: false,
      timer: 1500
    })
  } finally {
    commit('dashboard/load', false, {root: true});
  }
}

/**
 * @param state
 * @returns {Promise<void>}
 */
export async function crearFabricante({state, commit}) {
  if (validarPermisoComponente('crear-fabricantes')) {
    commit('dashboard/load', true, {root: true});

    await $http.post('/fabricantes', state.fabricante)
      .then((response) => {
        commit('dashboard/load', false, {root: true});
        Swal.fire({
          position: 'center',
          icon: 'success',
          title: response.data.mensaje,
          showConfirmButton: false,
          timer: 2000
        })
        commit('resetFabricante')
      })
      .catch((error) => {
        commit('dashboard/load', false, {root: true});
        Swal.fire({
          position: 'center',
          icon: 'error',
          title: error.message,
          showConfirmButton: false,
          timer: 2000
        })
      })
  }
}

/**
 * @param state
 * @returns {Promise<void>}
 */
export async function actualizarFabricante({state, commit, dispatch}, id) {

  try {
    commit('dashboard/load', true, {root: true});
    const response =  await $http.put('/fabricantes/' + id, state.fabricante)
    await Swal.fire({
      position: 'center',
      icon: 'success',
      title: response.data.mensaje,
      showConfirmButton: false,
      timer: 2000
    })
    dispatch('listarFabricantes')
    return response.data;
  } catch (error) {
    commit('dashboard/load', false, {root: true});
    Swal.fire({
      position: 'center',
      icon: 'error',
      title: error.message,
      showConfirmButton: false,
      timer: 2000
    })
  } finally {
    commit('dashboard/load', false, {root: true});
  }
}

/**
 *
 * @param id
 * @returns {Promise<void>}
 */
export async function inactivarFabricante({dispatch, commit}, fabricante) {
  commit('dashboard/load', true, {root: true});
  await $http.delete('/fabricantes/' + fabricante.id)
    .then((response) => {
      commit('dashboard/load', false, {root: true});
      Swal.fire({
        position: 'center',
        icon: 'success',
        title: response.data.mensaje,
        showConfirmButton: false,
        timer: 2000
      })
      dispatch('listarFabricantes')
    })
    .catch((error) => {
      commit('dashboard/load', false, {root: true});
      Swal.fire({
        position: 'center',
        icon: 'error',
        title: error.message,
        showConfirmButton: false,
        timer: 2000
      })
    })
}


/**
 * Fabricantes - Descargar archivo con todos los registros
 *
 * @param params -> {isVisible: '', isActive: '' }
 * @returns {Promise<void>}
 */
export async function downloadFileService({ commit }, params) {

  commit('dashboard/load', true, { root: true });

  await $http.get(`/fabricantes/descargar/informacion/${params.isVisible}/${params.isActive}`)
    .then(({ data: response }) => callbackResponseDownloadFile(response))
    .catch((error) => {
      this.$swal({
        position: 'center',
        icon: 'error',
        title: 'Error al tratar de generar el Archivo: ' + error,
        showConfirmButton: false,
        timer: 1500
      })
    }).finally(() => commit('dashboard/load', false, { root: true }));
}

/**
 * Fabricantes - Descargar archivo con todos los registros
 *
 * @param nombre -> nombre el archivo a descargar
 * @param archivo -> archivo a descarhgar. Este llega en formato base64
 * @returns {Promise<void>}
 */
function callbackResponseDownloadFile({ nombre, archivo }) {

  let linkTemporary = document.createElement("a");
  document.body.appendChild(linkTemporary);

  linkTemporary.setAttribute("type", "hidden");
  linkTemporary.href = "data:text/plain;base64," + archivo;
  linkTemporary.download = nombre;
  linkTemporary.click();

  document.body.removeChild(linkTemporary);
}


/**
 * Fabricantes - cargar informacion en Excel
 *
 * @param commit
 * @param params -> { data: formData, actions: {closeModal: this.closeModal, updateList: this.listarFabricantes} }
 * @returns {Promise<void>}
 */
export async function uploadFileWithInformationOfFabricantes({ commit }, params) {

  commit('dashboard/load', true, { root: true });

  await $http.post(`/fabricantes/importar/informacion`, params.data, {
    headers: { 'Content-Type': 'multipart/form-data' }
  })
    .then(({ data: response }) => callbackUploadFileWithInformationOfFabricantes('OK', commit, { result: response, actions: params.actions }))
    .catch(error => callbackUploadFileWithInformationOfFabricantes('ERROR', commit, { result: error, actions: params.actions }))
    .finally(() => commit('dashboard/load', false, { root: true }));
}

/**
 * Fabricantes - Callback cargar informacion en Excel
 *
 * @param statusCode -> codiogo identificativo: OK, ERRORS
 * @param commit
 * @param response
 */
function callbackUploadFileWithInformationOfFabricantes(statusCode, commit, dataResponse) {

  const { result, actions } = dataResponse;

  if (!'codigoRespuesta' in result) {
    generateInfoAlert('error', "Respuesta no esperada. Por favor verifica con el admin del sistema.");
    return false;
  }

  if (result.codigoRespuesta == 400) { // request fallido
    message = result.mensaje

    Swal.fire({
      position: 'center',
      icon: 'error',
      title: 'No se logro procesar la solicitud. Asegurate de estar usando la plantilla de fabricantes.',
      showCancelButton: true,
      showConfirmButton: true,
      confirmButtonText: "Descargar plantilla",
      cancelButtonText: "Salir"
    }).then(function (response) {
      if (response.isConfirmed) downloadTemplateExcelToLoadFabricantes({ commit });
    });
    return false;
  }

  let messageInfo = "";
  if (result.codigoRespuesta == 200) { // exitoso
    messageInfo = result.mensaje;

    actions.closeModal();
    actions.updateList();
  }

  if (result.codigoRespuesta == 409) { // Procesamiento en curso. Ya existe un agendamiento de este tipo.
    messageInfo = result.mensaje;
  }

  // Entidad no procesable -> Error de validación de datos
  if (result.hasOwnProperty('errors')) {
    Object.values(result.errors).forEach(error => messageInfo = error);
    generateInfoAlert('info', 'No se cargo un archivo valido.', messageInfo);
    return false;
  }

  Swal.fire({
    position: 'center',
    icon: 'info',
    title: messageInfo,
    showCancelButton: true,
    showConfirmButton: true,
    confirmButtonText: "Ver procesos agendados",
    cancelButtonText: "Salir"
  }).then(function (response) {
    if (response.isConfirmed) actions.showProccessBackground();
  });

  return false;

}

/**
 * Fabricantes - Callback cargar informacion en Excel
 *
 * @param icon: string -> representa el tipo de alerta: success, error
 * @param title: string -> representa el titulo de la alerta
 * @param html: string -> representa el contenido en HTML
 */
function generateInfoAlert(
  icon,
  title,
  html) {

  Swal.fire({
    position: 'center',
    icon,
    title,
    showConfirmButton: true,
    html
  });
}

/**
 * Fabricantes - descargar plantilla excel para cargar fabricantes
 *
 * @returns {Promise<void>}
 */
export async function downloadTemplateExcelToLoadFabricantes({ commit }) {

  commit('dashboard/load', true, { root: true });

  await $http.get('/fabricantes/descargar/plantilla')
    .then(({ data: response }) => callbackResponseDownloadFile(response))
    .catch(error => {
      this.$swal({
        position: 'center',
        icon: 'error',
        title: 'Error al tratar de descargar la plantilla de fabricantes ' + error,
        showConfirmButton: false,
        timer: 1500
      })
    })
    .finally(() => commit('dashboard/load', false, { root: true }));
}

/**
 * Fabricantes - cargar historico procesos en segundo plano
 *
 * @returns {Promise<void>}
 */
export async function loadProccessBackground({ commit, state }) {
  commit('dashboard/load', true, { root: true })

  await $http.post(`/fabricantes/historial/procedimientos/agendados`, { paginate: state.filtroProcesosAgendados })
    .then(({ data: response }) => commit('setProcesosEnSegundoPlano', response.procesos))
    .catch((error) => generateInfoAlert('error', "Proceso fallido"))
    .finally(() => commit('dashboard/load', false, { root: true }));
}

/**
 * Fabricantes - cambiar estado de los procesos en background
 *
 * @returns {Promise<void>}
 */
export async function deleteProcesBackground({ commit, state }, id) {
  commit('dashboard/load', true, { root: true })
  await $http.delete(`/fabricantes/historial/procedimientos/agendados/eliminar/${id}`)
    .then(({ data: response }) => {

      if (response.codigoRespuesta != 200) {
        generateInfoAlert('error', "Proceso fallido. " + response.mensaje)
        return false;
      }

      const newProcess = [];
      const currentProcess = state.procesosEnSegundoPlano.data

      if (typeof currentProcess !== 'object') return false;

      if (currentProcess.length > 0) {
        console.log("map");
        currentProcess.map(proceso => (proceso.id != id) && newProcess.push(proceso))
      } else {
        console.log("Object");
        Object.values(currentProcess).forEach(proceso => {
          if (proceso.id != id) newProcess.push(proceso)
        });
      }

      commit("setProcesosEnSegundoPlano", { ...state.procesosEnSegundoPlano, data: newProcess });
      generateInfoAlert('success', response.mensaje)
    })
    .catch(() => generateInfoAlert('error', "Proceso fallido"))
    .finally(() => commit('dashboard/load', false, { root: true }));
}

